<template>
  <t-form :data="formComponent" :rules="rulesComponent" ref="formComponent" @submit.native.prevent label-width="100px">
    <t-form-item label="组件名称" name="name">
      <t-input v-model="formComponent.name"></t-input>
    </t-form-item>
    <t-form-item label="选择看板" name="boardId">
      <t-select v-model="formComponent.boardId" filterable :disabled="disabledBoardId" placeholder="请选择">
        <t-option v-for="item in boardListCal" :key="item.key" :label="item.label" :value="item.value"></t-option>
      </t-select>
      <div style="display: inline-block; color: orange" v-show="!loadingBoardList && !boardListCal.length">
        <icon name="error-circle" />
        你还没有看板，先去自定义看板中新建一个吧
      </div>
    </t-form-item>
    <t-form-item label="图表样式" name="chartType">
      <t-radio-group v-model="formComponent.chartType" size="medium" @change="handleChartTypeChange">
        <t-radio-button
          v-for="item in chartTypeListCal"
          :value="item.value"
          :disabled="item.disabled"
          :key="item.value"
        >
          {{ item.label }}
        </t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="组件规格" name="size">
      <t-radio-group v-model="formComponent.size" size="medium">
        <t-radio-button v-for="item in sizeListCal" :value="item.value" :disabled="item.disabled" :key="item.value">
          {{ item.label }}
        </t-radio-button>
      </t-radio-group>
    </t-form-item>

    <t-form-item label="分指标tab" name="indexTabFlag" v-if="isChart && zhibiaoList.length > 1" key="indexTabFlag">
      <t-radio-group v-model="formComponent.indexTabDisplay" size="medium">
        <t-radio :value="1">是</t-radio>
        <t-radio :value="0" :disabled="mustIndexTabFlag">否</t-radio>
      </t-radio-group>
    </t-form-item>

    <t-form-item
      label="展示指标"
      name="indexSet"
      v-if="isChart && formComponent.indexTabDisplay === 1 && zhibiaoList.length > 1"
      key="indexSet"
    >
      <t-select v-model="formComponent.indexSet" multiple size="medium" placeholder="请选择">
        <t-option
          v-for="item in zhibiaoList"
          :key="item.zhibiaoTitle"
          :label="item.zhibiaoTitle"
          :value="item.zhibiaoTitle"
        ></t-option>
      </t-select>
    </t-form-item>

    <t-form-item label="展示条数" name="lineCount" v-if="isChart" key="lineCount">
      <t-select v-model="formComponent.lineCount" size="medium" placeholder="请选择" class="" style="">
        <t-option v-for="item in topNOptions" :key="item.label" :label="item.label" :value="item.value"></t-option>
      </t-select>
    </t-form-item>

    <t-form-item label="展示维度" name="dimensionType" v-if="isTable" key="dimensionType">
      <t-select v-model="formComponent.dimensionType" size="medium" placeholder="请选择" class="" style="">
        <t-option
          v-for="item in dimensionTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></t-option>
      </t-select>
    </t-form-item>

    <t-form-item label="主展示指标" name="primaryIndex" v-if="isNumber" key="primaryIndex">
      <t-select
        v-model="formComponent.primaryIndex"
        size="medium"
        placeholder="请选择"
        @change="handlePrimaryIndexChange"
      >
        <t-option v-for="item in zbIndexList" :key="item.value" :label="item.label" :value="item.value"></t-option>
      </t-select>
    </t-form-item>

    <t-form-item label="辅助指标" name="secondaryIndex" v-if="isNumber" key="secondaryIndex">
      <t-select v-model="formComponent.secondaryIndex" multiple size="medium" placeholder="请选择">
        <t-option
          v-for="item in zbIndexListCal"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :disabled="item.disabled"
        ></t-option>
      </t-select>
    </t-form-item>

    <t-form-item label="组件备注" name="remark" key="remark">
      <t-textarea :autosize="{ minRows: 2, maxRows: 5 }" v-model="formComponent.remark"></t-textarea>
    </t-form-item>
  </t-form>
</template>

<script>
import { pick } from 'lodash';
import { getGroupList } from '@/api/analysis/custom-overview';

export default {
  name: 'event-analysis-save-component-form',
  props: {
    zhibiaoList: {
      type: Array,
      required: true,
    },
    shuxingWeiduList: {
      type: Array,
      required: true,
    },
    saveType: {
      type: String,
      required: true,
    },
    boardInfo: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    formUnit: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loadingBoardList: true,
      boardList: [],
      chartTypeList: [
        { label: '折线图', value: 'chart_line' },
        { label: '数值', value: 'number' },
        { label: '表格', value: 'table' },
        { label: '柱状图', value: 'histogram' },
        { label: '环形图', value: 'circular_graph' },
        { label: '堆叠条形图', value: 'stacked_bar_chart' },
      ],
      disabledChartTypeList: [],
      sizeList: [
        { label: '小卡片(1*1)', value: 'small' },
        { label: '中卡片(2*2)', value: 'middle' },
        { label: '大卡片(2*4)', value: 'large' },
      ],
      disabledSizeList: [],
      zbIndexList: [
        // { label: '请选择', value: '' },
        { label: '合计值', value: 'total' },
        { label: '均值', value: 'mean' },
        { label: '最近一天的值', value: 'latest_day' },
      ],
      topNOptions: [
        { label: '前5项', value: 5 },
        { label: '前10项', value: 10 },
        { label: '前20项', value: 20 },
        { label: '前30项', value: 30 },
        { label: '前40项', value: 40 },
        { label: '前50项', value: 50 },
      ],
      dimensionTypeList: [
        { label: '按天展示', value: 'day' },
        { label: '合计值', value: 'total' },
      ],

      propBoardId: '',
      formComponent: {
        id: '',
        name: '',
        boardId: '',
        chartType: '',
        size: '',
        indexTabDisplay: 0,
        indexSet: [],
        primaryIndex: '',
        secondaryIndex: [],
        lineCount: 0,
        dimensionType: '',
        remark: '',
        ext: '',
      },
      rulesComponent: {
        name: [
          { required: true, message: '请输入组件名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
        ],
        boardId: [{ required: true, message: '请选择看板', trigger: 'blur' }],
        chartType: [{ required: true, message: '请选择图表样式', trigger: 'blur' }],
        size: [{ required: true, message: '请选择组件规格', trigger: 'blur' }],
        indexSet: [{ validator: this.validateIndexSet, trigger: 'blur' }],
        primaryIndex: [{ required: true, message: '请选择主展示指标', trigger: 'blur' }],
        lineCount: [{ required: true, message: '请输入展示条数', trigger: 'blur' }],
        dimensionType: [{ required: true, message: '请选择展示维度', trigger: 'blur' }],
        remark: [{ min: 1, max: 140, message: '长度在 1 到 140 个字符', trigger: 'blur' }],
      },
    };
  },
  watch: {
    'formComponent.chartType': {
      handler(newVal) {
        if (this.zhibiaoList.length > 1 && newVal === 'circular_graph') {
          this.formComponent.indexTabDisplay = 1;
        }
      },
      immediate: true,
    },
  },
  computed: {
    mustIndexTabFlag() {
      return this.zhibiaoList.length > 1 && this.formComponent.chartType === 'circular_graph';
    },
    isNumber() {
      return ['number'].includes(this.formComponent.chartType);
    },
    isChart() {
      return ['chart_line', 'histogram', 'circular_graph', 'stacked_bar_chart'].includes(this.formComponent.chartType);
    },
    isTable() {
      return ['table'].includes(this.formComponent.chartType);
    },
    chartTypeListCal() {
      return this.chartTypeList.map(item => {
        const nItem = {
          ...item,
          disabled: false,
        };
        if (this.disabledChartTypeList.includes(nItem.value)) {
          nItem.disabled = true;
        }
        if (this.formUnit === 'hour' && nItem.value !== 'chart_line') {
          nItem.disabled = true;
        }
        return nItem;
      });
    },
    sizeListCal() {
      const { chartType } = this.formComponent;
      return this.sizeList.map(item => {
        const nItem = {
          ...item,
          disabled: false,
        };

        // 全集卡片为：['small','middle','large']
        // 不同的图表类型，对应不同的卡片
        // eslint-disable-next-line default-case
        switch (chartType) {
          case 'number':
            // eslint-disable-next-line no-bitwise
            if (!~['small'].indexOf(nItem.value)) {
              nItem.disabled = true;
            }
            break;
          case 'chart_line':
            // eslint-disable-next-line no-bitwise
            if (!~['middle', 'large'].indexOf(nItem.value)) {
              nItem.disabled = true;
            }
            break;
          case 'table':
            // eslint-disable-next-line no-bitwise
            if (!~['middle', 'large'].indexOf(nItem.value)) {
              nItem.disabled = true;
            }
            break;
          case 'histogram':
            // eslint-disable-next-line no-bitwise
            if (!~['middle', 'large'].indexOf(nItem.value)) {
              nItem.disabled = true;
            }
            break;
          case 'circular_graph':
            // eslint-disable-next-line no-bitwise
            if (!~['middle', 'large'].indexOf(nItem.value)) {
              nItem.disabled = true;
            }
            break;
          case 'stacked_bar_chart':
            // eslint-disable-next-line no-bitwise
            if (!~['middle', 'large'].indexOf(nItem.value)) {
              nItem.disabled = true;
            }
            break;
        }
        return nItem;
      });
    },
    zbIndexListCal() {
      return this.zbIndexList
        .filter(item => item.value !== '')
        .map(item => ({
          ...item,
          disabled: item.value === this.formComponent.primaryIndex,
        }));
    },
    boardListCal() {
      if (this.propBoardId) {
        return [...this.boardList, { label: this.boardInfo.name, value: this.propBoardId, key: 'prop-board' }];
      }
      return this.boardList;
    },
    disabledBoardId() {
      if (this.propBoardId) {
        if (!this.formComponent.id) {
          return true;
        }
        if (!!this.formComponent.id && this.saveType === 'update') {
          return true;
        }
      }
      return false;
    },
  },
  created() {
    this.propBoardId = this.form.boardId; // 设置属性带过来的看板id
    const tmpForm = pick(this.form, [
      'id',
      'name',
      'boardId',
      'chartType',
      'size',
      'indexTabDisplay',
      'indexSet',
      'primaryIndex',
      'secondaryIndex',
      'lineCount',
      'dimensionType',
      'remark',
      'ext',
    ]);
    if (tmpForm.secondaryIndex && typeof tmpForm.secondaryIndex === 'string') {
      tmpForm.secondaryIndex = tmpForm.secondaryIndex.split(',');
    }
    if (tmpForm.indexSet && Array.isArray(tmpForm.indexSet)) {
      tmpForm.indexSet = tmpForm.indexSet.map(item => item.targetName);
      tmpForm.indexSet = tmpForm.indexSet.filter(item => this.zhibiaoList.find(zb => zb.zhibiaoTitle === item)); // 指标名称可能改变了，原来保存的名称不存在
    }
    Object.assign(this.formComponent, tmpForm);

    if (!this.formComponent.lineCount) {
      this.formComponent.lineCount = 5;
    }
    if (!this.formComponent.dimensionType) {
      this.formComponent.dimensionType = 'day';
    }
    this.setChartTypeAndSize();

    // 环状图如果是多指标默认要进行分tab且禁用
    if (this.zhibiaoList.length > 1 && this.formComponent.chartType === 'circular_graph') {
      this.formComponent.indexTabDisplay = 1;
    }

    // if (this.propBoardId) {
    //   this.boardList = [{ label: this.boardInfo.name, value: this.propBoardId }];
    // }
    this.handleGetBoardList();
  },
  methods: {
    async handleGetBoardList() {
      try {
        this.loadingBoardList = true;
        const res = await getGroupList({ params: { groupType: 0, isShowBoard: true } });
        const arr = [{ value: -1, label: '个人看板', key: '-1--1' }];
        res.forEach(groupItem => {
          if (groupItem.boardList) {
            groupItem.boardList.forEach(boardItem => {
              arr.push({
                label: boardItem.name,
                value: boardItem.id,
                key: `${groupItem.id}-${boardItem.id}`,
              });
            });
          }
        });
        this.boardList = arr;
      } finally {
        this.loadingBoardList = false;
      }
    },

    handleChartTypeChange() {
      const { size } = this.formComponent;
      const validSizeList = this.sizeListCal.filter(item => !item.disabled);
      if (validSizeList.findIndex(item => item.value === size) === -1) {
        this.formComponent.size = validSizeList[0].value;
      }
    },

    handlePrimaryIndexChange() {
      if (Array.isArray(this.formComponent.secondaryIndex)) {
        const idx = this.formComponent.secondaryIndex.findIndex(item => item === this.formComponent.primaryIndex);
        if (idx >= 0) {
          this.formComponent.secondaryIndex.splice(idx, 1);
        }
      }
    },

    setChartTypeAndSize() {
      const weiduList = this.shuxingWeiduList.filter(item => item.val !== 'all');
      let isSingle = false;
      if (this.zhibiaoList.length === 1 && weiduList.length === 0) {
        isSingle = true;
      }
      if (!isSingle) {
        this.disabledChartTypeList.push('number');
        // this.disabledSizeList = ['small'];
      }

      if (weiduList.length < 1) {
        this.disabledChartTypeList.push('circular_graph');
        // 如果是更新的话，发现多维度要禁用环状图，清空类型选择
        if (this.formComponent.chartType === 'circular_graph') {
          this.formComponent.chartType = '';
        }
      }
    },

    validate() {
      return this.$refs.formComponent.validate();
    },

    resetFields() {
      this.$refs.formComponent.reset();
    },

    getForm() {
      return JSON.parse(JSON.stringify(this.formComponent));
    },

    validateIndexSet(value) {
      if (this.formComponent.indexTabDisplay === 1 && value.length === 0) {
        // callback(new Error('请选择至少一个指标'));
        return { result: false, message: '请选择至少一个指标', type: 'error' };
      }
      return { result: true, message: '', type: 'success' };
    },
  },
};
</script>

<style scoped></style>
